import { render, staticRenderFns } from "./ActivationForm.vue?vue&type=template&id=a5e5eb92&scoped=true&"
import script from "./ActivationForm.ts?vue&type=script&lang=ts&"
export * from "./ActivationForm.ts?vue&type=script&lang=ts&"
import style0 from "./ActivationForm.scss?vue&type=style&index=0&id=a5e5eb92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e5eb92",
  null
  
)

export default component.exports